var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoNetwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 199,
    viewBox: "0 0 266 199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M265.7 173.98H0V174.087H265.7V173.98Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M188.647 180.676H183.067V180.782H188.647V180.676Z",
    fill: "#F0F0F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8544 177.219H34.4873V177.325H39.8544V177.219Z",
    fill: "#F0F0F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8306 180.625H81.5166V180.731H97.8306V180.625Z",
    fill: "#F0F0F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M124.347 177.594H113.879V177.7H124.347V177.594Z",
    fill: "#F0F0F0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M228.289 178.445H200.443V178.552H228.289V178.445Z",
    fill: "#F0F0F0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3623 177.219H42.459V177.325H65.3623V177.219Z",
    fill: "#F0F0F0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M240.192 178.496H231.424V178.602H240.192V178.496Z",
    fill: "#F0F0F0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M125.942 150.28H23.3288C21.6814 150.28 20.2998 148.898 20.2998 147.251V3.02898C20.2998 1.38164 21.6814 0 23.3288 0H125.942C127.589 0 128.971 1.38164 128.971 3.02898V147.251C128.971 148.951 127.642 150.28 125.942 150.28ZM23.3288 0.10628C21.7346 0.10628 20.4061 1.38164 20.4061 3.02898V147.251C20.4061 148.845 21.6814 150.173 23.3288 150.173H125.942C127.536 150.173 128.865 148.898 128.865 147.251V3.02898C128.865 1.43478 127.589 0.10628 125.942 0.10628H23.3288Z",
    fill: "#F0F0F0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M240.883 150.28H138.27C136.623 150.28 135.241 148.898 135.241 147.251V3.02898C135.241 1.38164 136.623 0 138.27 0H240.883C242.531 0 243.912 1.38164 243.912 3.02898V147.251C243.912 148.951 242.584 150.28 240.883 150.28ZM138.27 0.10628C136.676 0.10628 135.347 1.38164 135.347 3.02898V147.251C135.347 148.845 136.623 150.173 138.27 150.173H240.883C242.478 150.173 243.806 148.898 243.806 147.251V3.02898C243.806 1.43478 242.531 0.10628 240.883 0.10628H138.27Z",
    fill: "#F0F0F0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M231.636 142.094H217.022V173.978H231.636V142.094Z",
    fill: "#E6E6E6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M228.82 173.978H231.636V166.113H225.95L228.82 173.978Z",
    fill: "#F5F5F5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M148.206 142.094H133.593V173.978H148.206V142.094Z",
    fill: "#EBEBEB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M231.636 142.094H145.815V169.142H231.636V142.094Z",
    fill: "#F5F5F5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M148.667 144.703V159.316H174.121V144.703H148.667Z",
    fill: "#E6E6E6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M163.882 146.88H158.833C156.655 146.88 154.582 145.977 153.041 144.383H169.621C168.186 145.977 166.06 146.88 163.882 146.88Z",
    fill: "#F0F0F0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M176.002 144.672V159.285H201.456V144.672H176.002Z",
    fill: "#E6E6E6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M191.463 146.88H186.414C184.236 146.88 182.163 145.977 180.622 144.383H197.202C195.767 145.977 193.694 146.88 191.463 146.88Z",
    fill: "#F0F0F0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M203.335 144.691V159.305H228.789V144.691H203.335Z",
    fill: "#E6E6E6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M218.829 146.88H213.781C211.602 146.88 209.529 145.977 207.988 144.383H224.568C223.08 145.977 221.008 146.88 218.829 146.88Z",
    fill: "#F0F0F0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M148.579 173.978H145.815V166.113H151.501L148.579 173.978Z",
    fill: "#F5F5F5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M163.883 10.0977H33.4248V80.508H163.883V10.0977Z",
    fill: "#E6E6E6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M166.541 10.0977H34.6475V80.508H166.541V10.0977Z",
    fill: "#EBEBEB"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M163.883 80.5117H33.4248V85.5069H163.883V80.5117Z",
    fill: "#E6E6E6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M171.057 80.5117H39.1641V85.5069H171.057V80.5117Z",
    fill: "#E6E6E6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M162.782 76.6844V13.873L38.4349 13.873L38.4349 76.6844L162.782 76.6844Z",
    fill: "#FAFAFA"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7002 76.7356L67.8595 13.8711H78.3281L56.1688 76.7356H45.7002Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1739 55.427C40.0145 55.427 39.9082 55.3208 39.9082 55.1613V16.3692C39.9082 16.2098 40.0145 16.1035 40.1739 16.1035C40.3333 16.1035 40.4396 16.2098 40.4396 16.3692V55.1613C40.4927 55.3208 40.3333 55.427 40.1739 55.427Z",
    fill: "#E6E6E6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4014 76.7356L80.5607 13.8711H84.6525L62.4931 76.7356H58.4014Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M162.813 76.7079V13.8965H162.335V76.7079H162.813Z",
    fill: "#E6E6E6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M167.496 18.7072H36.9849L36.666 15.3594H167.124L167.496 18.7072Z",
    fill: "#EBEBEB"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M167.496 21.2037H36.9849L36.666 17.8027H167.124L167.496 21.2037Z",
    fill: "#EBEBEB"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M167.496 24.1271H36.9849L36.666 20.7793H167.124L167.496 24.1271Z",
    fill: "#EBEBEB"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M167.496 27.422H36.9849L36.666 24.0742H167.124L167.496 27.422Z",
    fill: "#EBEBEB"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M167.496 31.4049H36.9849L36.666 28.0039H167.124L167.496 31.4049Z",
    fill: "#E6E6E6"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M167.496 35.8166H36.9849L36.666 32.4688H167.124L167.496 35.8166Z",
    fill: "#E6E6E6"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M200.019 39.8516H181.845V60.8418H200.019V39.8516Z",
    fill: "#EBEBEB"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M203.738 39.8516H184.023V60.8418H203.738V39.8516Z",
    fill: "#F5F5F5"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M202.11 59.1503V41.5078H185.69V59.1503H202.11Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M189.656 53.4568V47.2395C189.656 46.4424 190.294 45.8047 191.091 45.8047H196.671C197.468 45.8047 198.105 46.4424 198.105 47.2395V53.4568C198.105 54.2539 197.468 54.8916 196.671 54.8916H191.091C190.294 54.8916 189.656 54.2539 189.656 53.4568Z",
    fill: "#FAFAFA"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M227.492 30.6641H209.318V51.6543H227.492V30.6641Z",
    fill: "#EBEBEB"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M231.212 30.6641H211.497V51.6543H231.212V30.6641Z",
    fill: "#F5F5F5"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M229.55 49.9432V32.3008H213.13V49.9432H229.55Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M217.13 44.2693V38.052C217.13 37.2549 217.768 36.6172 218.565 36.6172H224.144C224.941 36.6172 225.579 37.2549 225.579 38.052V44.2693C225.579 45.0664 224.941 45.7041 224.144 45.7041H218.565C217.768 45.7041 217.13 45.0664 217.13 44.2693Z",
    fill: "#FAFAFA"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M138.377 111.965H108.831V173.979H138.377V111.965Z",
    fill: "#E6E6E6"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M135.348 173.98H138.324V165.531H132.266L135.348 173.98Z",
    fill: "#E6E6E6"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7343 111.965H36.1885V173.979H65.7343V111.965Z",
    fill: "#E6E6E6"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M138.377 111.965H63.1309V168.825H138.377V111.965Z",
    fill: "#F5F5F5"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M135.4 114.516H64.7773V130.086H135.4V114.516Z",
    fill: "#E6E6E6"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M104.048 119.353H97.3523C94.4296 119.353 91.6664 117.44 89.7002 114.039H111.7C109.734 117.44 106.971 119.353 104.048 119.353Z",
    fill: "#F5F5F5"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1067 173.98H63.1309V165.531H69.1888L66.1067 173.98Z",
    fill: "#E6E6E6"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M135.4 132.582H64.7773V148.152H135.4V132.582Z",
    fill: "#E6E6E6"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M104.048 137.47H97.3523C94.4296 137.47 91.6664 135.557 89.7002 132.156H111.7C109.734 135.504 106.971 137.47 104.048 137.47Z",
    fill: "#F5F5F5"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M135.4 150.707H64.7773V166.277H135.4V150.707Z",
    fill: "#E6E6E6"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M104.048 155.541H97.3523C94.4296 155.541 91.6664 153.628 89.7002 150.227H111.7C109.734 153.628 106.971 155.541 104.048 155.541Z",
    fill: "#F5F5F5"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M203.26 136.411H204.163C204.163 134.604 204.163 129.981 204.27 119.46C204.429 100.329 204.748 99.1602 204.748 99.1602L202.675 107.981C201.294 117.706 202.994 127.537 203.26 136.411Z",
    fill: "#E6E6E6"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M199.381 104.684C194.758 100.114 185.724 99.5294 176.531 99.1043C172.917 98.9448 186.627 105.906 193.482 111.114C198.796 115.153 202.091 116.109 203.845 120.466C204.057 114.781 203.366 108.616 199.381 104.684Z",
    fill: "#E6E6E6"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M204.43 94.7472C207.565 88.7955 215.429 83.2158 224.251 81.0902C227.705 80.24 216.227 92.0902 211.816 99.6892C208.415 105.588 203.898 112.549 203.207 117.544C202.198 107.66 201.294 100.699 204.43 94.7472Z",
    fill: "#E6E6E6"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M204.057 142.094C200.975 142.094 198.424 139.702 198.265 136.62L197.733 131.359H210.328L209.796 136.62C209.637 139.702 207.139 142.094 204.057 142.094Z",
    fill: "#F0F0F0"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M211.178 133.381H196.937L196.512 127.535H211.55L211.178 133.381Z",
    fill: "#F5F5F5"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M132.85 198.002C189.756 198.002 235.888 195.313 235.888 191.997C235.888 188.681 189.756 185.992 132.85 185.992C75.9433 185.992 29.8115 188.681 29.8115 191.997C29.8115 195.313 75.9433 198.002 132.85 198.002Z",
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.977 79.2617C130.095 78.8376 124.189 79.5954 118.605 81.4904C113.021 83.3854 107.873 86.3793 103.464 90.2956C102.809 90.8793 101.956 91.1928 101.079 91.1728C100.201 91.1527 99.3641 90.8007 98.7359 90.1876L94.92 86.4603C94.5791 86.1278 94.31 85.7289 94.1296 85.2882C93.9491 84.8475 93.861 84.3745 93.8709 83.8984C93.8807 83.4223 93.9882 82.9533 94.1866 82.5204C94.3851 82.0875 94.6704 81.7 95.0247 81.3819C105.835 71.6665 119.969 66.4844 134.497 66.9101C149.025 67.3358 162.832 73.3367 173.055 83.6683C173.39 84.0068 173.652 84.4104 173.825 84.8542C173.998 85.298 174.078 85.7725 174.06 86.2484C174.042 86.7244 173.927 87.1916 173.722 87.6213C173.516 88.0509 173.225 88.4339 172.866 88.7465L168.845 92.2354C168.186 92.8101 167.334 93.1142 166.46 93.0865C165.586 93.0588 164.754 92.7015 164.133 92.0862C156.602 84.5551 146.602 80.0004 135.977 79.2617Z",
    fill: "#AB3882"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.494 86.0672C145.93 86.7916 155.769 91.1986 163.258 98.5024C163.601 98.8385 163.871 99.242 164.05 99.6875C164.229 100.133 164.313 100.611 164.298 101.09C164.284 101.57 164.169 102.042 163.963 102.475C163.757 102.909 163.463 103.295 163.1 103.609L160.097 106.216C159.444 106.782 158.604 107.085 157.74 107.065C156.877 107.044 156.052 106.702 155.427 106.105C149.461 100.413 141.6 97.1279 133.358 96.8833C125.115 96.6387 117.074 99.4517 110.781 104.781C110.122 105.345 109.277 105.643 108.41 105.616C107.543 105.588 106.717 105.238 106.095 104.634L103.251 101.858C102.907 101.525 102.636 101.123 102.455 100.68C102.273 100.236 102.186 99.7599 102.198 99.2809C102.211 98.8019 102.322 98.3307 102.525 97.8968C102.729 97.463 103.02 97.0761 103.38 96.7604C107.767 92.954 112.862 90.0502 118.372 88.2153C123.883 86.3804 129.701 85.6505 135.494 86.0672Z",
    fill: "#AB3882"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.613 112.595C127.494 112.156 121.433 114.032 116.631 117.85C115.967 118.391 115.128 118.67 114.273 118.635C113.417 118.599 112.604 118.252 111.987 117.658L110.613 116.314C110.261 115.969 109.986 115.554 109.807 115.095C109.627 114.636 109.547 114.145 109.571 113.653C109.595 113.161 109.724 112.679 109.948 112.241C110.172 111.802 110.487 111.416 110.871 111.108C117.092 106.072 124.915 103.437 132.915 103.684C140.915 103.93 148.56 107.041 154.46 112.45C154.813 112.782 155.092 113.186 155.279 113.633C155.466 114.081 155.557 114.563 155.546 115.048C155.534 115.533 155.421 116.01 155.213 116.448C155.005 116.886 154.708 117.276 154.339 117.592L152.884 118.856C152.233 119.413 151.401 119.711 150.545 119.696C149.689 119.681 148.869 119.353 148.238 118.774C144.186 115.144 139.04 112.97 133.613 112.595Z",
    fill: "#AB3882"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.626,
    cy: 132.718,
    r: 10.4138,
    fill: "#AB3882"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.206 41.3164C99.7661 41.3164 72.6582 68.4012 72.6582 101.811C72.6582 135.222 99.7661 162.306 133.206 162.306C166.647 162.306 193.755 135.222 193.755 101.811C193.755 68.4012 166.647 41.3164 133.206 41.3164ZM82.0911 101.811C82.0911 89.4401 86.4935 78.0975 93.819 69.2604L165.786 141.164C156.941 148.482 145.588 152.881 133.206 152.881C104.976 152.881 82.0911 130.016 82.0911 101.811ZM172.486 134.49L100.499 62.5668C109.363 55.184 120.764 50.741 133.206 50.741C161.437 50.741 184.322 73.6055 184.322 101.811C184.322 114.242 179.875 125.634 172.486 134.49Z",
    fill: "#FF1C26"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 121.096,
    height: 121.096,
    fill: "white",
    transform: "translate(72.6582 41.3164)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNetwork);
export default __webpack_public_path__ + "static/media/no_network.7e64aa03f9ce0dff1da67729b8ab085c.svg";
export { ForwardRef as ReactComponent };